import { IWallet } from '@App/redux/interfaces'

import { IJwtDecodeData, ITransactionSettings } from '@Interfaces/CommonInterfaces'

export interface ILoginData extends IJwtDecodeData {
  access_token: string
}

export interface ILoginDataError {
  status: boolean
  message: string
  data?: {
    error_code: string
  }
}

export interface ILoginSuccess {
  success: true
  username: string
  id: number
  access_token: string
}

export interface ILoginError {
  success: false
  message: string
  error_code?: string
}

export type ILoginResult = ILoginSuccess | ILoginError

export interface IRegisterData {
  username: string
  password: string
  password_confirmation: string
  email: string
  mobile_phone: string
  first_name: string
  last_name: string
  country: string
  birth: string
  city: string
}

export interface IRegisterResponse {
  id: string
  email: string
  mobile_phone: string
  country: string
  language: string
  nickname: string
  time_zone: string
  test: string
  created_at: string
  updated_at: string
  wallets: IWallet[]
}

export interface IEditAccountData {
  account_id: string
  name?: string
  trading_settings?: ITransactionSettings
  mirror_trade?: number
}
export interface ICreateAccountData {
  currency: string
}
export interface IMoveAccountMoneyData {
  from: string
  to: string
  amount?: number | string
}

export interface ICreateWatchlist {
  name: string
  market_ids: number[]
}

export type WatchlistOperation = 'add_market' | 'move_market' | 'delete_market' | 'change_status' | 'change_name'

export enum UpdateWatchlistOperation {
  AddMarket = 'add_market',
  MoveMarket = 'move_market',
  DeleteMarket = 'delete_market',
  ChangeStatus = 'change_status',
  ChangeName = 'change_name',
}

export interface IUpdateWatchlist {
  key: string
  operation: WatchlistOperation
  market_id?: number
  is_enabled?: boolean
  name?: string
  order?: number
}
